import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '../../components/Grid/GridContainer';
import WrapperContainer from '../../components/Container/WrapperContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import styles from '../../assets/jss/pages/SettingSellProductOrganizerStyle';
import Button from '../../components/Button/CustomButton';
import GridItem from '../../components/Grid/GridItem';
import Loader from '../../components/Loader/Loader';
import SnackBar from '../../components/Snackbar/Snackbar';
import DialogRegisterSettingSellProductOrganizer from './DialogRegisterSettingSellProductOrganizer';
import CustomTextSelector from '../../selectors/CustomText';

const useStyles = makeStyles(styles);

const SettingSellProductOrganizer = ({
    infoSettingProduct,
    isLoading,
    errorGetSetting,
    getSettingSellProductOrganizer,
    clearSettingProduct,
    companyId,
    updateSettingSellProductOrganizer,
    updateSuccess,
    errorUpdate,
    customTextSidebar,
}) => {
    const intl = useIntl();
    const classes = useStyles();
    const defaultSetting = {
        shipping_cost: null,
        cost_free_shipping: null,
        name_person_in_charge: '',
        phone_number_person_in_charge: '',
        email_person_in_charge: '',
    };

    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [infoSettingSell, setInfoSettingSell] = useState(defaultSetting);
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    useEffect(() => {
        if (companyId) {
            getSettingSellProductOrganizer({ company_id: companyId });
        }
    }, []);

    useEffect(() => {
        if (companyId) {
            getSettingSellProductOrganizer({ company_id: companyId });
        }
        return () => {
            clearSettingProduct();
        };
    }, [companyId, getSettingSellProductOrganizer]);

    useEffect(() => {
        if (updateSuccess) {
            getSettingSellProductOrganizer({ company_id: companyId });
            setSnackbar({
                isOpen: true,
                type: 'success',
                message: <FormattedMessage id="apiSuccess.default" />,
            });
        }
    }, [updateSuccess, updateSettingSellProductOrganizer]);

    useEffect(() => {
        if (!_.isEmpty(infoSettingProduct)) {
            setInfoSettingSell(infoSettingProduct);
        }
    }, [infoSettingProduct]);

    const handleUpdateSettingSell = (value) => {
        updateSettingSellProductOrganizer({
            company_id: companyId,
            data: value,
        });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    return (
        <>
            <WrapperContainer className={classes.wrapper}>
                <GridItem xs={12}>
                    <Box paddingBottom={4} paddingTop={4}>
                        <GridContainer>
                            <GridItem align="center" className={classes.title}>
                                <CustomTypography bold variant="h4" color="info">
                                    {customTextSidebar?.field_name?.product_sales_settings || intl.formatMessage({ id: 'settingSellProductOrganizer.pageTitle' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem>
                                <GridContainer className={classes.items}>
                                    <GridItem xs={12} sm={5} md={4}>
                                        <CustomTypography variant="h7" bold>
                                            送料
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8} bold>
                                        <CustomTypography variant="h7" bold>
                                            {_.isNull(infoSettingSell.shipping_cost) ? '' : `${intl.formatNumber(infoSettingSell.shipping_cost)}円`}
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer className={classes.items}>
                                    <GridItem xs={12} sm={5} md={4} style={{ paddingRight: '0' }}>
                                        <CustomTypography variant="h7" bold>
                                            送料が無料になる金額
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8}>
                                        <CustomTypography variant="h7" bold>
                                            { _.isNull(infoSettingSell.cost_free_shipping) ? '' : `${intl.formatNumber(infoSettingSell.cost_free_shipping)}円`}
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer className={classes.items}>
                                    <GridItem xs={12} sm={5} md={4}>
                                        <CustomTypography variant="h7" bold>
                                            お問合せ先情報
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8} />
                                </GridContainer>
                                <GridContainer className={classes.items}>
                                    <GridItem xs={12} sm={2} md={1} />
                                    <GridItem xs={12} sm={3} md={3}>
                                        <CustomTypography variant="h7" bold>
                                            担当者名
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8}>
                                        <CustomTypography variant="h7" bold>
                                            { infoSettingSell.name_person_in_charge }
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer className={classes.items}>
                                    <GridItem xs={12} sm={2} md={1} />
                                    <GridItem xs={12} sm={3} md={3}>
                                        <CustomTypography variant="h7" bold>
                                            電話番号
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8}>
                                        <CustomTypography variant="h7" bold>
                                            { infoSettingSell.phone_number_person_in_charge }
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer className={classes.items}>
                                    <GridItem xs={12} sm={2} md={1} />
                                    <GridItem xs={12} sm={3} md={3}>
                                        <CustomTypography variant="h7" bold>
                                            メールアドレス
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8}>
                                        <CustomTypography variant="h7" bold>
                                            { infoSettingSell.email_person_in_charge }
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                                        <Button style={{ fontSize: '1.75rem' }} color="info" size="lg" onClick={() => setIsOpenDialog(true)}>
                                            {
                                                !_.isEmpty(infoSettingSell.name_person_in_charge)
                                                    ? (customText?.content?.button_name?.change || '変更する')
                                                    : (customText?.content?.button_name?.sign_up || '登録する')
                                            }
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                            <DialogRegisterSettingSellProductOrganizer
                                isOpenDialog={isOpenDialog}
                                isCloseDialog={() => setIsOpenDialog(false)}
                                infoSettingSell={infoSettingSell}
                                updateSettingSell={(value) => handleUpdateSettingSell(value)}
                            />
                        </GridContainer>
                    </Box>
                </GridItem>
            </WrapperContainer>
            <Loader isLoading={isLoading} />
            <SnackBar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
            />
        </>
    );
};

SettingSellProductOrganizer.defaultProps = {
    infoSettingProduct: {},
    isLoading: false,
    errorGetSetting: {},
    getSettingSellProductOrganizer: () => {},
    clearSettingProduct: () => {},
    companyId: null,
    updateSettingSellProductOrganizer: () => {},
    updateSuccess: false,
    errorUpdate: {},
    customTextSidebar: {},
};

SettingSellProductOrganizer.propTypes = {
    infoSettingProduct: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool,
    errorGetSetting: PropTypes.oneOfType([() => null, PropTypes.object]),
    getSettingSellProductOrganizer: PropTypes.func,
    clearSettingProduct: PropTypes.func,
    companyId: PropTypes.number,
    updateSettingSellProductOrganizer: PropTypes.func,
    updateSuccess: PropTypes.bool,
    errorUpdate: PropTypes.oneOfType([() => null, PropTypes.object]),
    customTextSidebar: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default SettingSellProductOrganizer;
